import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// FORMS
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// HTTP
import { HttpClient, HttpClientModule } from '@angular/common/http';

//MATERIAL
// Card
import {MatCardModule} from '@angular/material/card';
// Form Fields
import {MatFormFieldModule } from '@angular/material/form-field';
//DIVIDER
import {MatDividerModule} from '@angular/material/divider';
// List
import {MatListModule} from '@angular/material/list';
// ICON
import {MatIconModule} from '@angular/material/icon';
// CHIPS
import {MatChipsModule} from '@angular/material/chips';
// TABS
import {MatTabsModule} from '@angular/material/tabs';
// BUTTON
import {MatButtonModule} from '@angular/material/button';
// INPUt
import {MatInputModule} from '@angular/material/input';
// MENU
import {MatMenuModule} from '@angular/material/menu';
// Progress Bar
import {MatProgressBarModule} from '@angular/material/progress-bar';
// Tooltip
import {MatTooltipModule} from '@angular/material/tooltip';
//SnackBar
import {MatSnackBarModule} from '@angular/material/snack-bar';
// MatCheckbox
import {MatCheckboxModule } from '@angular/material/checkbox'
// DATE PICKER
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
// Dialog
import {MatDialogModule } from '@angular/material/dialog';
// Expansion Panel
import {MatExpansionModule} from '@angular/material/expansion';
// Mat Tree
import {MatTreeModule} from '@angular/material/tree';
// Mat Drag Drop
import { DragDropModule } from '@angular/cdk/drag-drop';
//Spinner
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// Toolbar
import {MatToolbarModule} from '@angular/material/toolbar';
//Stepper
import {MatStepperModule} from '@angular/material/stepper';
import { ApiConnectorService } from './___LOGIC/__api/api-connector.service';
import { AuthService } from './___LOGIC/__auth/auth.service';
// Button Toggle
import {MatButtonToggleModule} from '@angular/material/button-toggle';


// Badge
import {MatBadgeModule} from '@angular/material/badge';


// Select Module
import {MatSelectModule} from '@angular/material/select';
// COMPONENTS
// Webapp
import { HomeComponent } from './___COMPONENTS/__pages/home/home.component';
import { LoginComponent } from './___COMPONENTS/__pages/login/login.component';
import { WebappMenuComponent } from './___COMPONENTS/__pages/webapp-menu/webapp-menu.component';
//common
import { HeaderComponent } from './___COMPONENTS/__common/header/header.component';
import { FooterComponent } from './___COMPONENTS/__common/footer/footer.component';
//cards
import { CardWithFooterComponent } from './___COMPONENTS/__common/__cards/card-with-footer/card-with-footer.component';
import { CardImageSimpleComponent } from './___COMPONENTS/__common/__cards/card-image-simple/card-image-simple.component';
import { MyProfileComponent } from './___COMPONENTS/__pages/my-profile/my-profile.component';
import { MyProjectComponent } from './___COMPONENTS/__pages/my-project/my-project.component';
import { EditDialogComponent } from './___COMPONENTS/__common/edit-dialog/edit-dialog.component';
import { DateRenderComponent } from './___COMPONENTS/__common/date-render/date-render.component';
import { SmartParagraphComponent } from './___COMPONENTS/__common/smart-paragraph/smart-paragraph.component';
import { ChecklistComponent } from './___COMPONENTS/__utilities/checklist/checklist.component';
import { SubAppComponent } from './___COMPONENTS/__apps/sub-app/sub-app.component';
import { VisaHelperComponent } from './___COMPONENTS/__apps/visa-helper/visa-helper.component';
import { TransportHelperComponent } from './___COMPONENTS/__apps/transport-helper/transport-helper.component';
import { MigrationHelperComponent } from './___COMPONENTS/__apps/migration-helper/migration-helper.component';
import { HealthHelperComponent } from './___COMPONENTS/__apps/health-helper/health-helper.component';
import { AccommodationHelperComponent } from './___COMPONENTS/__apps/accommodation-helper/accommodation-helper.component';
import { BudgetHelperComponent } from './___COMPONENTS/__apps/budget-helper/budget-helper.component';
import { TableOfContentComponent } from './___COMPONENTS/__common/table-of-content/table-of-content.component';
import { IntroCardComponent } from './___COMPONENTS/__utilities/intro-card/intro-card.component';
import { LegalHelperComponent } from './___COMPONENTS/__apps/legal-helper/legal-helper.component';
import { VisaPipelineComponent } from './___COMPONENTS/__utilities/visa-pipeline/visa-pipeline.component';
import { TaskDetailsComponent } from './___COMPONENTS/__utilities/task-details/task-details.component';
import { SmartTooltipComponent } from './___COMPONENTS/__common/smart-tooltip/smart-tooltip.component';
import { CardCtaComponent } from './___COMPONENTS/__common/__cards/card-cta/card-cta.component';
import { CardWithContentComponent } from './___COMPONENTS/__common/__cards/card-with-content/card-with-content.component';
import { AppSectionComponent } from './___COMPONENTS/__common/__sections/app-section/app-section.component';
import { AppSectionAccordionComponent } from './___COMPONENTS/__common/__sections/app-section-accordion/app-section-accordion.component';
import { SectionPostListComponent } from './___COMPONENTS/__common/__sections/section-post-list/section-post-list.component';
import { SectionMultiAccordionComponent } from './___COMPONENTS/__common/__sections/section-multi-accordion/section-multi-accordion.component';
import { CardArticleComponent } from './___COMPONENTS/__common/__cards/card-article/card-article.component';
import { SectionPostListImgComponent } from './___COMPONENTS/__common/__sections/section-post-list-img/section-post-list-img.component';
import { CardImageOverlayComponent } from './___COMPONENTS/__common/__cards/card-image-overlay/card-image-overlay.component';
import { TimelineVerticalComponent } from './___COMPONENTS/__common/__sections/timeline-vertical/timeline-vertical.component';
import { CardParagraphsComponent } from './___COMPONENTS/__common/__cards/card-paragraphs/card-paragraphs.component';
import { SectionStepsComponent } from './___COMPONENTS/__common/__sections/section-steps/section-steps.component';
import { SectionChecklistComponent } from './___COMPONENTS/__common/__sections/section-checklist/section-checklist.component';
import { SectionGridArtistsComponent } from './___COMPONENTS/__common/__sections/section-grid-artists/section-grid-artists.component';
import { SectionAlbumSliderComponent } from './___COMPONENTS/__common/__sections/section-album-slider/section-album-slider.component';
import { RequirementListComponent } from './___COMPONENTS/__utilities/requirement-list/requirement-list.component';
import { RequirementDetailComponent } from './___COMPONENTS/__utilities/requirement-detail/requirement-detail.component';
import { SettingsPageComponent } from './___COMPONENTS/__pages/settings-page/settings-page.component';
import { CardUtilityComponent } from './___COMPONENTS/__common/__cards/card-utility/card-utility.component';
import { LoadingScreenComponent } from './___COMPONENTS/__common/loading-screen/loading-screen.component';
import { FaqsPageComponent } from './___COMPONENTS/__pages/faqs-page/faqs-page.component';
import { ClientProcessComponent } from './___COMPONENTS/__pages/client-process/client-process.component';
import { AppInitService } from './___LOGIC/___common/__init/app-init.service';
import { LogViewerComponent } from './___COMPONENTS/__common/log-viewer/log-viewer.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { RecoverPasswordComponent } from './___COMPONENTS/__pages/recover-password/recover-password.component';
import { RegisterPageComponent } from './___COMPONENTS/__pages/register-page/register-page.component';



// TRANSLATE
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MegaCardComponent } from './___COMPONENTS/__common/__cards/mega-card/mega-card.component';
import { SmartCardComponent } from './___COMPONENTS/__common/__cards/smart-card/smart-card.component';
import { ExploreComponent } from './___COMPONENTS/explore/explore.component';
import { DownloadZipComponent } from './___COMPONENTS/__files/download-zip/download-zip.component';
import { BannerCardComponent } from './___COMPONENTS/__common/__cards/banner-card/banner-card.component';
import { FileListComponent } from './___COMPONENTS/__files/file-list/file-list.component';
import { FileUploadComponent } from './___COMPONENTS/__files/file-upload/file-upload.component';
import { LoadingModalComponent } from './___COMPONENTS/__common/loading-modal/loading-modal.component';
import { CustomSnackbarComponent } from './___COMPONENTS/__common/custom-snackbar/custom-snackbar.component';
import { MedicalInsuranceComponent } from './___COMPONENTS/__apps/medical-insurance/medical-insurance.component';
import { PricingPlansComponent } from './___COMPONENTS/pricing-plans/pricing-plans.component';
import { FaqListComponent } from './___COMPONENTS/faq-list/faq-list.component';
import { AcceptTermsCheckComponent } from './___COMPONENTS/__common/accept-terms-check/accept-terms-check.component';
import { MaintenancePageComponent } from './___COMPONENTS/__pages/maintenance-page/maintenance-page.component';
import { ArticleComponent } from './___COMPONENTS/article/article.component';
import { MobileSliderFullComponent } from './___COMPONENTS/mobile-slider-full/mobile-slider-full.component';
import { WebappOnboardingComponent } from './___COMPONENTS/webapp-onboarding/webapp-onboarding.component';
import { SliderHorizontalComponent } from './___COMPONENTS/slider-horizontal/slider-horizontal.component';
import { CardPdfGuideComponent } from './___COMPONENTS/__common/__cards/card-pdf-guide/card-pdf-guide.component';
import { ArticleLinkComponent } from './___COMPONENTS/article-link/article-link.component';
import { PdfViewerComponent } from './___COMPONENTS/__utilities/pdf-viewer/pdf-viewer.component';
import { AcceptTermsPolicyCheckComponent } from './___COMPONENTS/accept-terms-policy-check/accept-terms-policy-check.component';
import { MyOrdersComponent } from './___COMPONENTS/my-orders/my-orders.component';
import { PhotoCarouselComponent } from './___COMPONENTS/photo-carousel/photo-carousel.component';
import { SimpleFooterComponent } from './___COMPONENTS/simple-footer/simple-footer.component';
import { ImagePortraitComponent } from './___COMPONENTS/image-portrait/image-portrait.component';
import { ImageViewerComponent } from './___COMPONENTS/image-viewer/image-viewer.component';
import { PdfGuideSellComponent } from './___COMPONENTS/pdf-guide-sell/pdf-guide-sell.component';
import { PdfGuidePageComponent } from './___COMPONENTS/pdf-guide-page/pdf-guide-page.component';
import { RedirectPageComponent } from './___COMPONENTS/redirect-page/redirect-page.component';
import { ConfigService } from './___LOGIC/___common/__config/config.service';

export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.load();
}

// Function to create TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    //COMPONENTS
    //common
    HeaderComponent,
    LoginComponent,
    DateRenderComponent,
    SmartParagraphComponent,
    TableOfContentComponent,
    IntroCardComponent,
    SmartTooltipComponent,
    // Utilities
    VisaPipelineComponent,
    TaskDetailsComponent,
    RequirementListComponent,
    RequirementDetailComponent,
    
    HomeComponent,
    FooterComponent,
    CardWithFooterComponent,
    CardImageSimpleComponent,
    WebappMenuComponent,
    MyProfileComponent,
    MyProjectComponent,
    EditDialogComponent,
    ChecklistComponent,
    SubAppComponent,
    VisaHelperComponent,
    TransportHelperComponent,
    MigrationHelperComponent,
    HealthHelperComponent,
    AccommodationHelperComponent,
    BudgetHelperComponent,
    LegalHelperComponent,
    CardCtaComponent,
    CardWithContentComponent,
    AppSectionComponent,
    AppSectionAccordionComponent,
    SectionPostListComponent,
    SectionMultiAccordionComponent,
    CardArticleComponent,
    SectionPostListImgComponent,
    CardImageOverlayComponent,
    TimelineVerticalComponent,
    CardParagraphsComponent,
    SectionStepsComponent,
    SectionChecklistComponent,
    SectionGridArtistsComponent,
    SectionAlbumSliderComponent,
    ClientProcessComponent,
    SettingsPageComponent,
    CardUtilityComponent,
    LoadingScreenComponent,
    FaqsPageComponent,
    MyOrdersComponent,
    LogViewerComponent,
    RegisterPageComponent,
    RecoverPasswordComponent,
    MegaCardComponent,
    SmartCardComponent,
    ExploreComponent,
    MedicalInsuranceComponent,
    FileUploadComponent,
    FileListComponent,
    DownloadZipComponent,
    BannerCardComponent,
    LoadingModalComponent,
    CustomSnackbarComponent,
    PricingPlansComponent,
    FaqListComponent,
    AcceptTermsCheckComponent,
    MaintenancePageComponent,
    ArticleComponent,
    PdfViewerComponent,
    MobileSliderFullComponent,
    WebappOnboardingComponent,
    SliderHorizontalComponent,
    CardPdfGuideComponent,
    ArticleLinkComponent,
    AcceptTermsPolicyCheckComponent,
    PhotoCarouselComponent,
    SimpleFooterComponent,
    ImagePortraitComponent,
    ImageViewerComponent,
    PdfGuideSellComponent,
    PdfGuidePageComponent,
    RedirectPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    // FORMS
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    //INPUT
    MatInputModule,
    // MATERIAL
    // Button
    MatButtonModule,
    //Card
    MatCardModule,
    //DIalog
    MatDialogModule,
    //Expansion
    MatExpansionModule,
    // Spinner
    MatProgressSpinnerModule,
    // Divider
    MatDividerModule,
    // List
    MatListModule,
    // ICON
    MatIconModule,
    // Chips
    MatChipsModule,
    // Tabs
    MatTabsModule,
    // Menu
    MatMenuModule,
    // Progress Bar
    MatProgressBarModule,
    // MatBadge
    MatBadgeModule,
    // Tooltip
    MatTooltipModule,
    // Snackbar
    MatSnackBarModule,
    //
    MatCheckboxModule,
    //Stepper
    MatStepperModule,
    // Date Picker
    MatDatepickerModule,
    MatNativeDateModule,
    // Toolbar
    MatToolbarModule,
    // Button Toggle
    MatButtonToggleModule,
    //
    MatSelectModule,
    //
    MatTreeModule,
    DragDropModule,
    //Calendar
    //FullCalendarModule, // Add FullCalendarModule
    //Pull Down to Refresh
    HammerModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  entryComponents: [CustomSnackbarComponent],
  providers: [AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true, // Ensures multiple initializers can run if needed
    },
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    ,AuthService,ApiConnectorService],
  bootstrap: [AppComponent]
})
export class AppModule { }
